import styled from "styled-components";

export const ControlCont = styled.div`
  display: flex;
  width: 100%;
`;

export const Control = styled.div<{ highlightWidth: number, highlightXPos: number, isMounted: boolean }>`
    display: inline-flex;
    justify-content: space-between;
    border-radius: 44px;
    background: var(--surface-primary, #080808);
    border: 1px solid var(--stroke-tertiary, #252525);
    padding: 4px;
    overflow: hidden;
    position: relative;
    width: 100%;
  
    input {
      opacity: 0;
      margin: 0;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      position: absolute;
      width: 100%;
      cursor: pointer;
      height: 100%;
    }

  ::before {
    content: "";
    border-radius: var(--units-88, 88px);
    background: var(--states-minimal-alpha-8, rgba(255, 255, 255, 0.08));
    backdrop-filter: blur(20px);
    width: ${props => props.highlightWidth ? `${props.highlightWidth}px` : 'auto'};
    transform: translateX(${props => props.highlightXPos ? `${props.highlightXPos}px` : 0});
    position: absolute;
    top: 4px;
    bottom: 4px;
    left: 0;
    z-index: 0;
    justify-content: center;
    align-items: center;
    gap: var(--units-4, 4px);
    flex: 1 0 0;
    align-self: stretch;
  }

  // this is part 2 of the useEffect component.ready = true
  /* only allow transition once component is mounted */
  ${({ isMounted }) =>
    isMounted &&
    `
    ::before {
      transition: transform 0.3s ease, width 0.3s ease;
    }
  `}
`;

export const Cont = styled.div`
  .selected-item {
    text-align: center;
  }
  width: 100%;

`
export const Segment = styled.div<{ isActive: boolean }>`
    width: 100%; // uncomment for each segment to have matching width
    min-width: 97px;
    position: relative;
    text-align: center;
    z-index: 1;
    padding: var(--units-8, 8px) 24px;
    justify-content: center;
    align-items: center;
    gap: var(--units-4, 4px);
    flex: 1 0 0;
    align-self: stretch;

  label {
    color: var(--text-primary, #FFF);
    /* Web/Text/L/Semibold */
    font-family: var(--type-family-space-grotesk, "Space Grotesk");
    font-size: var(--Text-L-L-size, 16px);
    font-style: normal;
    font-weight: var(--type-weight-Regular, 300);
    line-height: var(--Text-L-L-line-height, 20px); /* 125% */
    display: block;
    transition: color 0.5s ease;
    text-align: center;
    cursor: pointer;
  }

   ${({ isActive }) =>
    isActive &&
    `
    label {
      color: var(--text-primary, #FFF);
      font-weight: var(--type-weight-Semibold, 600);
    }
  `}
`
